"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationStaff',
  data: function data() {
    return {
      tab: 'staff',
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      roles: []
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        activate: '激活',
        disable: '停用',
        leave: '离职',
        enable: '启用',
        assign_role: '绑权限组',
        bind_permission: '加权限'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      var api = this.tab === 'staff' ? _decoration.decorationStaffListApi : _decoration.decorationRoleListApi;
      api(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
        if (_this.tab === 'role') _this.roles = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt(this.tab === 'role' ? '权限组名称' : '职员姓名', this.tab === 'role' ? '新权限组' : '邀请职员').then(function (_ref) {
        var value = _ref.value;
        var api = _this2.tab === 'role' ? _decoration.decorationRoleSaveApi : _decoration.decorationStaffSaveApi;
        var payload = _this2.tab === 'role' ? {
          name: value || '业务查看组',
          dataScope: 'self',
          permissionCodes: ['decoration:lead:view']
        } : {
          name: value || '新工人',
          jobType: 'worker'
        };
        api(payload).then(function () {
          _this2.$message.success('已保存');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      var exec = function exec(payload) {
        var api = _this3.tab === 'staff' ? _decoration.decorationStaffActionApi : _decoration.decorationRoleActionApi;
        var id = _this3.tab === 'staff' ? row.staff.id : row.role.id;
        api(id, payload).then(function () {
          _this3.$message.success('已更新');
          _this3.loadCurrent();
        });
      };
      if (action === 'assign_role') {
        (0, _decoration.decorationRoleListApi)({
          page: 1,
          limit: 20,
          status: 'enabled'
        }).then(function (data) {
          var first = (data.list || [])[0];
          if (!first) {
            _this3.$message.warning('请先创建权限组');
            return;
          }
          exec({
            action: action,
            roleId: first.role.id
          });
        });
        return;
      }
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        var payload = {
          action: action
        };
        if (action === 'bind_permission') payload.permissionCodes = ['decoration:todo:view'];
        exec(payload);
      }).catch(function () {});
    }
  }
};